import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { Container, Row, Col } from 'react-bootstrap'
import LoginForm from '../../../components/LoginForm'
import img from '../../../assets/images/aspirantes.png'
import { loginCandidateRequest } from '../../../redux/actions/authActions'
import { getUserAuthenticated } from '../../../redux/actions/authActions'
import { navigate } from '@reach/router'

const LoginCandidate = ({ auth, loginCandidateRequest, getUserAuthenticated }) => {
  const { isAuth, errors, user } = auth
  
  useEffect(() => {
    getUserAuthenticated()

    if (isAuth && 'inscrito' in user) navigate('/aspirantes/inicio');
  }, [isAuth])

  return ( 
  <>
    <Container fluid>
      <Row className="wrapper">
        <Col 
          className="wrapper__container"
          xs={{span:10}}
          md={{span:10}}
          lg={{span: 6}}
        >
          <Row>
            <Col 
              className="header"
              xs={{span: 12}}
              md={{span: 12}}
            >
              <h2>Instituto Tecnol&oacute;gico de Hermosillo</h2>
            </Col>
            <Col
              className="slider"
              xs={{span: 12}}
              md={{span: 7}}
            >
              <img className="slider__img" alt="ith" src={img} />
            </Col>
            <Col
              className="form"
              xs={{span: 12}}
              md={{span: 5}}
            >
              <h3>Aceptados Nuevo Ingreso</h3>
              <hr/>

              <LoginForm
                userLabelName="CURP"
                loginRequest={ loginCandidateRequest }
                loginTo="/aspirantes/inicio"
                errors={errors}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  </>
  )
}

export default connect( state => ({ auth: state.auth }), { loginCandidateRequest, getUserAuthenticated })(LoginCandidate)